const roles = [
  {
    id: 1,
    name: "Admin",
    isVisible: true,
  },
  {
    id: 2,
    name: "Owner",
    isVisible: false,
  },
  {
    id: 3,
    name: "Certifier",
    isVisible: true,
  },
  {
    id: 0,
    name: "Member",
    isVisible: true,
  },
  {
    id: 4,
    name: "Contributor",
    isVisible: true,
  },
];

export default roles;
